import { every } from 'lodash';

export function getQuizPage(state) {
  return state.quiz;
}

export function getVideoLecture(state) {
  return state.videoLecture;
}

export function isEmptyOptions(state, getters) {
  return getters.getQuizPage
    && getters.getQuizPage.answers
    && every(getters.getQuizPage.answers, answer => !answer.content);
}
